<template>
	<div class="accommodationcard__info">
		<!-- Beds & additional beds -->
		<div class="accommodationcard__info--item">
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 26" v-bind:svg-inline="''" v-bind:class="'accommodationcard__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M40 12V7c0-.6-.4-1-1-1H28c-.6 0-1 .4-1 1v5c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1s1-.4 1-1v-1h11v1c0 .6.4 1 1 1s1-.4 1-1v-7c0-.6-.4-1-1-1zM29 8h9v4h-.5v-2c0-.3-.2-.5-.5-.5h-7c-.3 0-.5.2-.5.5v2H29V8zm7.5 4h-6v-1.5h6V12zM28 17v-3h11v3H28zM23 12h-1V7c0-.6-.4-1-1-1H5c-.6 0-1 .4-1 1v5H3c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1s1-.4 1-1v-1h18v1c0 .6.4 1 1 1s1-.4 1-1v-7c0-.6-.4-1-1-1zM6 8h14v4h-.5v-2c0-.3-.2-.5-.5-.5h-5c-.3 0-.5.2-.5.5v2h-1v-2c0-.3-.2-.5-.5-.5H7c-.3 0-.5.2-.5.5v2H6V8zm12.5 4h-4v-1.5h4V12zm-7 0h-4v-1.5h4V12zM4 17v-3h18v3H4z"/></svg>

			<span class="accommodationcard__beds">
				{{ beds }}
				<template v-if="beds == 1">
					{{ $t('accommodation.bed') }}
				</template>
				<template v-else>
					{{ $t('accommodation.beds') }}
				</template>
			</span>

			<span v-if="extraBeds !== 0" class="accommodationcard__beds">
				{{ extraBeds }}
				<template v-if="extraBeds == 1">
					{{ $t('accommodation.additionalBed') }}
				</template>
				<template v-else>
					{{ $t('accommodation.additionalBeds') }}
				</template>
			</span>
		</div>

		<!-- Bedrooms & loft -->
		<div class="accommodationcard__info--item">
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" v-bind:svg-inline="''" v-bind:class="'accommodationcard__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="st0" d="M23 3H3c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h11v4c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm-1 7h-6V5h6v5zM4 16V5h11v11H4zm12 5V11h6v10h-6z"/></svg>

			<span class="accommodationcard__bedsrooms">
				{{ bedrooms }}
				<template v-if="bedrooms == 1">
					{{ $t('accommodation.bedroom') }}
				</template>
				<template v-else>
					{{ $t('accommodation.bedrooms') }}
				</template>
			</span>

			<span v-if="loft === true" class="accommodationcard__bedsrooms">
				1 {{ $t('accommodation.loft') }}
			</span>
		</div>

		<!-- Area -->
		<div class="accommodationcard__info--item">
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" v-bind:svg-inline="''" v-bind:class="'accommodationcard__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="st0" d="M23 3H3c-.6 0-1 .4-1 1v13c0 .6.4 1 1 1h11v4c0 .6.4 1 1 1h8c.6 0 1-.4 1-1V4c0-.6-.4-1-1-1zm-7 13.8l6-6v2.6l-6 6V17v-.2zm6-11.5L11.3 16H8.7l11-11H22v.3zM4.7 16l11-11h2.6l-11 11H4.7zm5.6-11L4 11.3V8.7L7.7 5h2.6zM4 12.7L11.7 5h2.6L4 15.3v-2.6zM6.3 5L4 7.3V5h2.3zm6.4 11L22 6.7v2.6L15.2 16c-.1 0-.2 0-.2-.1h-2.3zm3.3 4.7l6-6v2.6L18.3 21H16v-.3zm3.7.3l2.3-2.3V21h-2.3z"/></svg>
			<span class="accommodationcard__area">{{ area }} m²</span>
		</div>

		<!-- Distance to lift -->
		<div v-if="distanceToLift !== null" class="accommodationcard__info--item">
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" v-bind:svg-inline="''" v-bind:class="'accommodationcard__icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="st0" d="M20.2 23.3c-.5.3-1.5.3-2.5-.3L13 20.1l4.1-5c.5-.6.5-1.6-.4-2.3-1.7-1.5-7.6-4.4-7.6-4.4-.7 1-1 1.8-1.1 1.9-.4.9 0 1.9.8 2.5 1.7 1 4.7 2.2 4.7 2.2l-2.8 3.8-7.5-4.6c-.5-.3-1.1-.1-1.4.3-.3.5-.1 1.1.3 1.4l14.1 8.7c.8.5 1.8.8 2.6.8.7 0 1.4-.1 1.9-.5.6-.4.8-1 .5-1.4-.1-.6-.5-.5-1-.2M18.4 9.6s.8-4 .9-4.2v-.6C19.1 3.7 18 3 17 3.2c-.3 0-2.6.5-5 2.2-.6.4-1.1.9-1.6 1.4L5.8 4.4l.4-.7c.1-.2 0-.5-.2-.7-.2-.1-.5 0-.7.2l-.3.7-.9-.4c-.2-.1-.5 0-.7.2-.1.2 0 .5.2.7l.9.5-.4.7c-.2.2-.1.5.2.6.1 0 .2.1.2.1.2 0 .3-.1.4-.3l.4-.8 8 4.2c1.1-1.1 2.6-1.9 3.4-2.1l-.5 2.5c-.1.4.1.8.4 1l3.5 2.5c.2.1.4.2.6.2.3 0 .6-.1.8-.4.3-.4.2-1.1-.2-1.4l-2.9-2.1zM22.1.5c-1.4 0-2.5 1.1-2.5 2.5s1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5S23.4.5 22.1.5"/></svg>
			<span class="accommodationcard__distance-to-lift">
				{{ distanceToLift }} m
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AccommodationInfo',
	props: {
		beds: {
			type: Number,
			default: 0
		},
		bedrooms: {
			type: Number,
			default: 0
		},
		area: {
			type: Number,
			default: 0
		},
		distanceToLift: {
			type: Number,
			default: 0
		},
		extraBeds: {
			type: Number,
			default: 0
		},
		loft: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.accommodationcard {
	&__info {
		display: flex;
		&--item {
			text-align: center;
			color: $colorGrey8;
			font-family: Saira;
			font-size: 12px;
			line-height: 18px;
			padding: 0 20px;
			&:first-child {
				padding: 0 20px 0 0;
			}
			&:nth-child(even) {
				border-left: 1px solid $colorPrimary2;
				border-right: 1px solid $colorPrimary2;
			}

			&:last-child {
				border-right: none;
			}
		}
		span {
			display: block;
		}
	}
	&__icon {
		height: 26px;
		fill: $colorPrimary6;
	}
}
</style>
